import { AutogenLayoutGPMappingTable } from "./autogen/AutogenLayoutGPMappingTable";

export class GPMappingTable extends AutogenLayoutGPMappingTable {

}

